import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
// @mui
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

// -----------------------------------------------------------

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1079.000000 513.000000">
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN}
          stroke="none"
          strokeWidth="1"
          fillRule="evenodd"
          transform="translate(0.000000,588.000000) scale(0.100000,-0.100000)"
        >
          <path d="M5314 4436 c-180 -70 -321 -172 -539 -390 -61 -61 -136 -140 -167
-176 -58 -66 -245 -302 -308 -387 -130 -178 -171 -222 -213 -234 -23 -6 -58
-17 -77 -25 -19 -7 -66 -25 -105 -39 -86 -33 -108 -42 -215 -94 -47 -22 -91
-41 -98 -41 -21 0 6 32 49 60 l39 24 0 303 0 303 -145 0 c-80 0 -146 -1 -147
-2 -1 -2 -4 -189 -8 -417 l-5 -413 -40 -34 c-22 -18 -43 -30 -46 -26 -4 4 -10
115 -13 247 -4 131 -9 241 -11 244 -3 2 -5 -3 -5 -11 0 -9 -7 -19 -16 -22 -8
-3 -12 -10 -9 -16 8 -12 -1 -13 -23 -1 -17 9 -132 -15 -160 -33 -7 -4 -16 -6
-19 -2 -3 3 -13 -2 -21 -11 -23 -23 -31 -118 -31 -395 -1 -147 -5 -246 -12
-261 -11 -23 -71 -53 -87 -43 -5 3 -11 123 -15 266 -5 235 -11 300 -24 263 -4
-10 -12 -9 -35 3 -18 10 -40 13 -59 9 -18 -4 -29 -3 -29 4 0 6 8 12 18 13 9 1
-19 4 -63 7 -58 4 -83 2 -91 -6 -13 -15 -28 -17 -19 -3 3 6 -3 10 -14 10 -21
0 -21 -5 -21 -202 0 -112 -3 -260 -6 -329 -4 -70 -3 -129 2 -132 5 -3 61 -1
124 3 114 9 210 29 325 70 93 33 293 136 360 185 178 130 244 169 455 268 103
48 160 65 160 49 0 -16 -196 -217 -280 -287 -95 -80 -241 -178 -351 -238 -113
-61 -344 -152 -424 -167 -22 -4 -53 -13 -70 -19 -16 -7 -57 -16 -90 -21 -33
-5 -107 -16 -165 -24 -139 -21 -343 -20 -445 0 -44 9 -98 20 -120 24 -77 14
-185 65 -253 118 -50 40 -79 85 -102 160 -17 54 -18 55 -25 29 -4 -16 -5 -55
-2 -86 16 -183 195 -335 487 -415 212 -58 600 -55 865 7 445 104 859 401 1200
861 125 168 140 183 220 212 139 50 306 104 368 118 40 9 39 8 -22 -186 -11
-37 -21 -77 -21 -90 0 -13 -7 -41 -14 -63 -26 -72 -49 -238 -50 -345 -1 -92 2
-109 21 -141 33 -51 95 -83 165 -84 75 0 82 8 67 76 -14 66 -6 246 16 344 8
39 22 104 31 145 24 114 50 209 104 392 6 20 19 39 28 43 61 25 332 84 332 73
0 -2 -11 -37 -25 -76 -14 -39 -25 -77 -25 -84 0 -7 -6 -25 -14 -40 -8 -15 -17
-42 -21 -60 -3 -18 -15 -55 -25 -83 -10 -27 -47 -138 -81 -245 -34 -107 -68
-208 -75 -225 -14 -33 -41 -106 -53 -145 -11 -35 -59 -129 -83 -162 -25 -37
-16 -48 38 -48 96 0 188 39 230 98 19 25 53 94 84 167 13 31 123 365 161 490
12 39 30 93 39 120 17 48 28 82 86 268 15 48 35 92 43 97 9 4 46 14 81 20 36
7 103 21 150 31 47 10 101 19 121 19 20 0 49 5 65 10 35 12 194 35 564 81 151
19 225 22 535 22 336 0 366 -1 448 -21 49 -12 97 -22 108 -22 10 0 59 -16 108
-35 48 -19 92 -35 96 -35 16 0 -69 69 -115 94 -25 14 -77 36 -115 50 -64 23
-108 33 -250 56 -66 11 -587 11 -695 0 -47 -5 -152 -16 -235 -24 -82 -9 -164
-20 -182 -25 -18 -5 -63 -12 -100 -16 -37 -4 -131 -18 -208 -31 -298 -52 -327
-56 -336 -47 -13 13 32 129 92 238 49 90 121 178 169 207 33 20 109 38 159 38
65 0 51 26 -29 54 -52 18 -168 21 -219 5 -54 -16 -133 -57 -161 -82 -46 -41
-108 -122 -139 -182 -18 -33 -35 -67 -40 -75 -17 -30 -51 -111 -51 -120 0 -6
-8 -29 -19 -53 -10 -23 -23 -54 -29 -68 -11 -28 -38 -37 -222 -75 -147 -31
-134 -31 -127 5 4 18 13 47 20 64 8 18 24 59 36 92 44 119 90 224 187 430 43
93 104 196 141 242 l35 42 -34 21 c-44 27 -117 25 -194 -4z m-184 -324 c0 -4
-24 -54 -52 -112 -29 -58 -61 -126 -72 -150 -10 -25 -27 -63 -37 -86 -11 -23
-19 -45 -19 -49 0 -4 -6 -21 -14 -38 -28 -60 -48 -112 -62 -158 -18 -60 -36
-74 -114 -93 -111 -28 -204 -53 -233 -65 -30 -12 -47 -8 -47 12 0 13 75 124
113 167 12 14 51 64 87 110 124 164 202 252 315 360 105 101 135 123 135 102z"/>
<path d="M3667 4383 c-6 -11 -1 -108 6 -119 3 -5 33 -7 66 -6 l62 4 -3 61 -3
62 -62 3 c-34 2 -63 -1 -66 -5z"/>
<path d="M3474 4217 c-3 -8 -4 -34 -2 -58 l3 -44 55 0 55 0 0 55 0 55 -53 3
c-38 2 -54 -1 -58 -11z"/>
<path d="M3640 4040 l0 -70 80 0 80 0 0 70 0 70 -80 0 -80 0 0 -70z"/>
<path d="M7741 4046 c12 -10 59 -15 59 -6 0 5 -14 10 -32 10 -17 0 -29 -2 -27
-4z"/>
<path d="M7984 3991 c4 -6 11 -9 16 -6 5 3 11 1 14 -4 8 -13 -26 -23 -38 -11
-12 12 -56 14 -56 2 0 -4 5 -13 11 -19 14 -14 -10 -21 -86 -26 -40 -3 -37 -4
20 -5 41 -1 80 3 95 11 30 16 105 10 121 -9 9 -11 8 -14 -5 -14 -9 0 -16 5
-16 10 0 6 -21 10 -46 10 -25 0 -43 -4 -39 -9 3 -5 -5 -12 -17 -14 -18 -3 -16
-5 10 -7 47 -4 50 -4 58 -12 4 -5 17 -8 28 -8 12 0 54 -12 95 -25 40 -13 77
-22 81 -20 4 3 36 -7 71 -20 35 -14 71 -24 79 -23 9 2 27 -4 41 -13 13 -9 39
-19 57 -22 19 -4 48 -13 65 -21 18 -8 49 -19 69 -26 21 -6 40 -16 43 -21 4 -5
16 -9 29 -9 12 0 26 -4 32 -9 16 -16 128 -71 144 -71 10 1 4 9 -15 25 -47 39
-192 135 -204 135 -10 0 -65 34 -106 65 -10 8 -26 15 -35 15 -9 0 -25 7 -36
15 -10 8 -27 15 -36 15 -10 0 -33 9 -53 20 -20 11 -43 20 -53 20 -9 0 -30 9
-47 20 -16 11 -41 20 -55 20 -24 0 -84 18 -105 31 -5 4 -39 10 -74 14 -46 5
-62 4 -57 -4z m96 -25 c-7 -7 -14 -6 -21 1 -9 9 -7 12 9 10 14 -1 18 -5 12
-11z m308 -131 c-3 -3 -9 2 -12 12 -6 14 -5 15 5 6 7 -7 10 -15 7 -18z"/>
<path d="M2255 3970 c-16 -4 -50 -8 -75 -9 -25 0 -70 -10 -100 -21 -30 -11
-63 -20 -73 -20 -11 0 -31 -8 -45 -18 -15 -10 -38 -23 -52 -30 -38 -19 -74
-76 -62 -99 41 -75 181 -122 430 -144 101 -9 144 -10 183 -1 28 7 81 12 117
12 39 0 91 9 126 20 33 11 69 20 81 20 28 0 52 25 33 33 -8 4 -5 8 9 12 13 4
20 11 18 15 -3 5 -1 26 3 48 10 44 0 72 -25 72 -13 0 -12 5 7 25 l23 25 -29 0
c-22 0 -26 -3 -14 -10 9 -6 10 -10 3 -10 -7 0 -16 6 -20 13 -15 24 -69 45
-128 51 -33 4 -87 11 -120 15 -73 11 -249 12 -290 1z"/>
<path d="M3483 3972 c-21 -3 -23 -9 -23 -57 0 -53 0 -54 33 -60 19 -4 47 -5
63 -3 28 3 29 4 29 63 l0 60 -40 0 c-22 1 -50 -1 -62 -3z"/>
<path d="M7710 3960 c-12 -7 -12 -12 -3 -21 9 -9 16 -9 27 1 26 21 5 39 -24
20z"/>
<path d="M7488 3953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M7815 3950 c3 -5 8 -10 11 -10 2 0 4 5 4 10 0 6 -5 10 -11 10 -5 0
-7 -4 -4 -10z"/>
<path d="M7767 3943 c-4 -3 -7 -11 -7 -17 0 -6 5 -5 12 2 6 6 9 14 7 17 -3 3
-9 2 -12 -2z"/>
<path d="M2850 3875 c-10 -12 -10 -15 4 -15 9 0 16 7 16 15 0 8 -2 15 -4 15
-2 0 -9 -7 -16 -15z"/>
<path d="M2855 3760 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z"/>
<path d="M3270 3715 c0 -11 -12 -15 -50 -15 -27 0 -50 -4 -50 -10 0 -6 27 -10
60 -10 57 0 60 1 60 25 0 14 -4 25 -10 25 -5 0 -10 -7 -10 -15z"/>
<path d="M1840 3513 c1 -148 4 -158 60 -194 35 -22 175 -66 235 -73 28 -4 75
-11 105 -16 87 -14 177 -12 183 3 4 10 38 16 121 21 117 7 181 21 250 54 39
19 39 19 12 26 -25 6 -37 26 -16 26 6 0 10 9 10 21 0 13 -5 19 -13 16 -10 -4
-14 7 -14 40 -1 57 -41 104 -82 98 -14 -2 -82 -9 -151 -16 -216 -20 -491 24
-638 103 -29 15 -55 28 -58 28 -2 0 -4 -62 -4 -137z"/>
<path d="M7534 3530 c-8 -8 -8 -27 -1 -63 13 -73 2 -201 -23 -272 -31 -87 -98
-223 -137 -276 -18 -26 -33 -50 -33 -55 -1 -15 -54 -70 -74 -78 -18 -6 -18 -2
-12 66 8 80 41 266 56 314 6 17 10 46 10 66 0 32 -4 37 -40 52 -22 9 -58 16
-80 16 -38 0 -90 -17 -90 -29 0 -4 -31 -56 -70 -116 -38 -61 -75 -121 -80
-134 -12 -28 -109 -173 -144 -216 -19 -23 -27 -27 -36 -18 -10 9 -9 22 4 59 9
26 16 54 16 61 0 15 62 179 89 238 11 22 29 68 41 103 21 62 21 63 3 95 -23
39 -66 56 -145 56 -81 1 -88 -3 -88 -55 0 -37 -32 -157 -59 -219 -8 -19 -20
-51 -66 -180 -9 -27 -21 -70 -25 -95 -6 -36 -16 -52 -56 -86 -56 -49 -121 -85
-140 -77 -30 11 -34 83 -9 163 16 54 83 221 94 235 16 20 91 198 91 216 0 43
-135 112 -187 95 -17 -5 -33 -33 -58 -101 -100 -269 -328 -582 -394 -540 -30
18 0 131 73 281 57 117 106 243 106 272 0 21 -9 38 -30 56 -36 30 -74 38 -150
34 l-55 -3 -7 -54 c-7 -58 -6 -57 -101 -276 -95 -220 -101 -241 -101 -321 0
-60 4 -77 26 -111 14 -22 43 -48 63 -57 101 -48 165 -27 285 92 l85 85 6 -56
c11 -96 59 -140 154 -141 72 0 123 18 209 74 l77 50 14 -33 c17 -40 39 -60 89
-81 100 -41 171 4 289 186 30 45 67 109 83 140 16 32 35 58 43 58 9 0 11 -7 6
-22 -4 -13 -9 -83 -12 -156 -5 -127 -4 -134 18 -167 15 -21 40 -41 65 -51 37
-14 44 -14 86 3 52 20 103 64 168 143 25 30 47 57 50 60 26 24 137 205 174
285 56 118 57 121 84 205 43 133 37 226 -15 264 -31 23 -122 33 -139 16z"/>
<path d="M8195 3414 c-181 -38 -307 -123 -440 -298 -42 -55 -104 -174 -117
-223 -4 -18 -12 -50 -18 -70 -25 -97 6 -220 64 -258 43 -28 106 -30 171 -6 72
27 123 63 202 139 68 67 66 67 78 -18 11 -75 88 -140 166 -140 59 0 169 39
234 83 70 47 183 153 220 208 27 38 32 94 8 94 -7 0 -56 -43 -111 -96 -151
-147 -258 -196 -283 -131 -19 46 21 188 96 347 53 113 85 193 85 214 0 29 -47
79 -99 105 -39 20 -198 58 -227 55 -5 -1 -18 -3 -29 -5z m100 -133 c8 -28 -90
-253 -139 -316 -109 -141 -141 -178 -173 -199 -39 -27 -87 -34 -98 -15 -20 31
9 154 55 239 10 19 24 46 30 58 34 77 178 225 234 241 53 16 84 13 91 -8z"/>
<path d="M1840 3112 l0 -138 33 -30 c31 -29 97 -59 187 -83 55 -15 320 -37
343 -28 15 6 17 25 17 147 l0 140 -67 0 c-60 0 -107 7 -268 41 -75 15 -95 21
-101 30 -3 5 -15 9 -27 9 -12 0 -40 12 -62 25 -22 14 -43 25 -47 25 -5 0 -8
-62 -8 -138z"/>
<path d="M1847 2853 c-4 -3 -7 -66 -7 -138 0 -153 6 -167 87 -202 122 -52 195
-67 396 -79 l98 -6 -3 143 -3 144 -50 7 c-27 4 -95 12 -150 18 -55 6 -131 21
-170 31 -73 21 -176 66 -186 81 -3 4 -8 5 -12 1z"/>
<path d="M6115 2053 c-61 -13 -95 -36 -110 -78 -15 -38 -15 -45 0 -82 14 -34
25 -44 67 -62 28 -12 61 -21 73 -21 12 0 34 -9 49 -21 21 -16 24 -24 16 -39
-17 -31 -68 -34 -135 -9 -41 15 -60 18 -63 10 -2 -6 -11 -19 -20 -27 -14 -15
-14 -18 8 -34 34 -25 89 -40 150 -40 94 0 160 49 160 121 0 56 -32 84 -131
117 -67 21 -85 31 -87 48 -4 30 45 50 90 36 80 -24 85 -24 98 9 16 38 10 44
-65 63 -61 16 -66 17 -100 9z"/>
<path d="M3797 2043 c-4 -3 -7 -92 -7 -196 l0 -189 133 4 c132 3 151 8 201 48
48 40 71 148 45 217 -17 46 -69 92 -123 108 -50 15 -237 21 -249 8z m254 -109
c25 -24 29 -35 29 -84 0 -46 -4 -60 -22 -77 -29 -27 -93 -46 -138 -41 l-35 3
-3 104 c-1 58 0 111 3 119 4 12 19 14 71 9 54 -4 71 -10 95 -33z"/>
<path d="M4454 2033 c-3 -10 -10 -26 -15 -36 -6 -10 -27 -57 -48 -105 -21 -48
-50 -112 -63 -142 -40 -88 -40 -87 -10 -92 44 -6 59 1 77 38 l16 35 97 -3 96
-3 10 -32 c8 -31 11 -33 57 -33 27 0 49 4 49 10 0 5 -16 44 -35 87 -20 43 -57
125 -83 183 l-48 105 -47 3 c-38 3 -48 0 -53 -15z m85 -159 c12 -25 18 -50 15
-55 -8 -14 -94 -11 -94 3 0 27 33 98 46 98 7 0 22 -21 33 -46z"/>
<path d="M4800 2010 c0 -40 0 -40 40 -41 63 -2 64 -3 71 -29 4 -14 7 -82 8
-152 l1 -128 45 0 45 0 0 145 c0 163 1 165 80 165 45 0 56 14 46 55 l-6 25
-165 0 -165 0 0 -40z"/>
<path d="M5397 2032 c-10 -10 -17 -22 -17 -25 0 -4 -20 -50 -45 -103 -25 -52
-45 -97 -45 -100 0 -3 -13 -34 -30 -69 -16 -35 -30 -67 -30 -70 0 -3 19 -5 43
-5 40 0 45 3 60 35 l17 35 90 0 90 0 17 -35 c15 -32 20 -35 60 -35 45 0 53 11
34 48 -27 51 -91 193 -91 201 0 6 -11 31 -25 57 -14 26 -25 53 -25 59 0 29
-79 34 -103 7z m86 -182 c7 -35 1 -40 -44 -40 -34 0 -39 3 -39 23 0 12 10 37
21 56 l21 35 18 -24 c10 -14 21 -36 23 -50z"/>
<path d="M6464 2035 c-4 -9 -5 -79 -2 -156 4 -136 5 -140 33 -169 61 -63 159
-79 243 -39 36 18 49 32 69 75 22 48 23 63 21 176 l-3 123 -45 0 -45 0 -5
-138 c-4 -124 -7 -140 -25 -153 -48 -35 -105 -29 -132 13 -14 21 -19 56 -23
152 l-5 126 -38 3 c-27 2 -39 -1 -43 -13z"/>
<path d="M7007 2043 c-4 -3 -7 -91 -7 -195 l0 -188 135 0 c105 0 142 4 170 17
19 9 35 23 35 30 0 7 5 13 10 13 6 0 10 18 10 39 0 31 -7 46 -31 70 l-30 31
20 26 c24 30 27 90 7 116 -26 35 -80 48 -199 48 -63 0 -117 -3 -120 -7z m201
-74 c37 -13 45 -30 26 -57 -15 -22 -80 -38 -114 -27 -15 5 -20 15 -20 45 0 21
6 41 13 43 21 9 63 7 95 -4z m48 -174 c16 -22 7 -51 -20 -63 -18 -8 -93 -10
-128 -3 -13 2 -9 79 5 84 27 10 132 -3 143 -18z"/>
<path d="M3235 1869 c-71 -3 -166 -8 -210 -9 -73 -2 -76 -3 -38 -11 63 -12
497 -29 506 -19 5 4 6 17 2 29 -7 24 -15 24 -260 10z"/>
<path d="M7640 1851 l0 -32 103 6 c196 11 432 27 435 30 2 2 -96 7 -395 21
l-143 7 0 -32z"/>
<path d="M4806 1420 c-3 -19 -15 -34 -31 -42 -32 -14 -32 -26 0 -38 14 -5 27
-20 31 -35 8 -32 22 -32 34 0 5 14 21 30 35 37 32 14 32 22 -1 36 -14 7 -30
26 -36 42 -13 38 -24 38 -32 0z m36 -37 c17 -15 17 -17 1 -35 -15 -17 -18 -17
-34 -2 -15 13 -16 20 -6 35 14 23 16 23 39 2z"/>
<path d="M5789 1350 c-80 -35 -90 -38 -130 -28 -24 5 -89 8 -144 5 -112 -5
-189 -29 -265 -81 -40 -28 -79 -46 -133 -63 -18 -6 -97 24 -95 36 3 26 -5 41
-21 41 -11 0 -23 -5 -26 -10 -4 -6 -21 -8 -39 -5 -30 6 -37 2 -89 -54 -65 -71
-141 -204 -157 -276 -11 -49 -10 -51 17 -73 15 -13 45 -30 65 -38 20 -9 49
-32 64 -52 15 -21 44 -55 65 -77 21 -22 47 -61 58 -86 20 -45 56 -79 84 -79 8
0 22 -9 32 -20 10 -11 27 -20 38 -20 11 0 35 -13 54 -30 18 -16 44 -30 57 -30
13 0 29 -7 36 -15 8 -9 30 -15 57 -15 28 0 61 -9 91 -25 66 -35 116 -34 150 5
18 20 36 30 55 30 31 0 87 47 87 74 0 8 18 25 40 37 35 20 70 68 70 98 0 6 13
17 29 26 36 18 66 90 58 135 -6 25 0 37 36 78 23 27 49 62 58 78 11 20 32 35
68 49 30 11 55 25 58 32 2 6 -42 97 -98 202 -84 156 -106 191 -123 190 -12 0
-60 -18 -107 -39z m184 -110 c36 -69 78 -149 94 -178 24 -45 26 -54 13 -62 -8
-6 -21 -9 -29 -7 -7 1 -55 81 -106 177 l-93 175 22 17 c11 9 24 14 27 10 4 -4
36 -63 72 -132z m-1030 -36 c-3 -8 -14 -14 -24 -14 -20 0 -23 -5 -33 -52 -4
-18 -14 -28 -29 -30 -15 -2 -23 -11 -25 -28 -6 -53 -12 -67 -38 -79 -22 -10
-25 -16 -21 -44 5 -37 -10 -77 -30 -77 -7 0 -13 -4 -13 -10 0 -5 -7 -10 -15
-10 -51 0 73 250 166 335 37 33 74 39 62 9z m104 -30 c50 -18 55 -18 99 -1 26
9 49 16 50 14 2 -2 -19 -35 -46 -74 -28 -39 -50 -80 -50 -92 0 -22 27 -41 60
-41 36 0 123 51 165 96 l41 44 62 -38 c383 -231 414 -252 437 -299 13 -26 14
-41 5 -72 -10 -38 -33 -71 -49 -71 -4 0 -18 12 -32 26 -13 15 -56 48 -96 75
-40 27 -76 57 -82 66 -5 10 -13 15 -17 11 -10 -11 22 -55 54 -75 67 -43 132
-96 137 -114 11 -34 -14 -87 -51 -109 l-34 -22 -48 39 c-70 58 -111 85 -123
81 -6 -2 23 -29 64 -61 87 -66 99 -91 61 -125 -35 -31 -57 -28 -118 18 -29 22
-56 40 -59 40 -18 0 -3 -20 38 -49 25 -18 45 -36 45 -42 0 -19 -41 -49 -67
-49 -16 0 -51 13 -79 29 l-51 30 -6 65 c-9 92 -39 146 -83 146 -15 0 -29 11
-41 30 -17 29 -57 50 -69 37 -4 -3 -16 6 -28 20 -16 18 -32 26 -53 25 -19 0
-38 7 -49 19 -22 25 -60 24 -74 0 -5 -11 -10 -37 -10 -58 l0 -38 -51 55 c-28
30 -64 70 -81 87 -43 46 -45 104 -4 136 16 13 27 31 26 42 -4 34 -1 44 24 67
13 13 26 36 30 51 4 17 16 31 31 37 14 5 25 18 25 28 0 21 20 44 35 39 5 -3
34 -13 62 -23z m164 -75 c19 -10 20 -12 4 -29 -19 -21 -72 -42 -79 -31 -5 7
41 71 50 71 3 0 14 -5 25 -11z m-201 -421 c0 -20 -1 -21 -24 -12 -16 6 -22 45
-9 58 10 9 33 -23 33 -46z m84 -10 c9 -35 8 -38 -14 -38 -16 0 -20 7 -20 30 0
36 25 41 34 8z m95 -65 c1 -14 -5 -23 -14 -23 -16 0 -22 60 -8 74 9 9 21 -20
22 -51z m91 -65 c0 -10 -7 -18 -15 -18 -11 0 -15 11 -15 38 1 35 2 36 15 18 8
-11 15 -28 15 -38z"/>
<path d="M6056 797 c-3 -18 -15 -43 -26 -55 -26 -27 -25 -32 3 -32 25 0 48
-21 62 -55 7 -17 9 -15 17 15 6 19 16 47 24 63 15 28 12 47 -9 47 -6 0 -23 12
-38 26 l-27 25 -6 -34z m34 -27 c0 -5 7 -10 15 -10 18 0 18 -2 4 -34 -11 -24
-13 -24 -34 -8 -19 14 -21 21 -12 39 10 23 27 31 27 13z"/>
</g>
</svg>

    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>;
}
